import { lazy, Suspense } from 'react';

const LazyApplicationFooter = lazy(() => import('./application-footer.jsx'));

const ApplicationFooter = (props) => (
  <Suspense fallback={null}>
    <div id="footer-wrapper" className="hidden-mobile">
      <LazyApplicationFooter {...props} />
    </div>
  </Suspense>
);

export default ApplicationFooter;
